export default __webpack_public_path__ + "6cd00c5a13830d5f189ec4be30e43b29.png";